import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0819b41e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-time" }, "时间"),
  /*#__PURE__*/_createElementVNode("span", { class: "col-type" }, "类型"),
  /*#__PURE__*/_createElementVNode("span", { class: "col-content" }, "内容")
], -1))
const _hoisted_2 = { class: "table-body" }
const _hoisted_3 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_4 = {
  key: 1,
  class: "empty-tip"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-time" }
const _hoisted_7 = { class: "col-type" }
const _hoisted_8 = ["onMouseenter"]
const _hoisted_9 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_10 = {
  key: 1,
  class: "empty-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "msg-page",
      onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading && _ctx.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "加载中..."))
          : (!_ctx.loading && _ctx.list.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无消息"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "table-row",
                    onClick: ($event: any) => (_ctx.goDetail(item))
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatTime(item.createTime)), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.messageTitle || '--'), 1),
                    _createElementVNode("span", {
                      class: "col-content",
                      onMouseenter: (e) => _ctx.showTooltip(e, item.messageContent),
                      onMousemove: _cache[0] || (_cache[0] = (e) => _ctx.moveTooltip(e)),
                      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
                    }, _toDisplayString(item.messageContent || '--'), 41, _hoisted_8)
                  ], 8, _hoisted_5))
                }), 128)),
                (_ctx.loadingMore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "加载中..."))
                  : (_ctx.noMore)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "没有更多了"))
                    : _createCommentVNode("", true)
              ], 64))
      ])
    ], 32),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.tooltip.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "msg-tooltip",
            style: _normalizeStyle({ left: _ctx.tooltip.x + 'px', top: _ctx.tooltip.y + 'px' })
          }, _toDisplayString(_ctx.tooltip.text), 5))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}